import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconHouseBlue from '../build/icon-house-blue'

export const IconHouseBlueComponent: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconHouseBlue} />
}

export default IconHouseBlueComponent
